import angular from 'angular';
import moment from 'moment';
import { dynamicSort } from '@/shared/utils/dynamicSort';

angular
  .module('cloudX')
  .controller('EmployeeOvertimeDialogCtrl', [
    '$element',
    '$q',
    '$http',
    'appUrls',
    'flySvc',
    'close',
    'employee',
    employeeOvertimeDialogCtrl,
  ]);
const mapCorrection = x => ({
  ...x,
  date: moment.utc(x.date).toDate(),
  createDate: x.createDate ? moment.utc(x.createDate).toDate() : null,
});

function employeeOvertimeDialogCtrl($element, $q, $http, appUrls, flySvc, close, employee) {
  var vm = this;
  vm.loading = true;
  vm.saving = false;
  vm.employee = employee;
  vm.data = [];
  vm.model = {};
  vm.overtimeRemaining = null;
  vm.correction = 0;
  vm.factor = 1;
  vm.remark = '';

  vm.reloadData = function() {
    return $http
      .get(`${appUrls.api}/api/employee/OvertimeCorrection/${vm.employee.employeeID}`)
      .then(({ data }) => {
        vm.data = (data || []).map(mapCorrection);
      }, flySvc.error);
  };
  vm.refreshRemainingOvertime = function() {
    return $http
      .get(`${appUrls.api}/api/employee/OvertimeRemaining/${vm.employee.employeeID}`)
      .then(({ data }) => {
        vm.overtimeRemaining = data;
        vm.factor = data > 0 ? -1 : 1;
      }, flySvc.error);
  };
  $q.all([vm.reloadData(), vm.refreshRemainingOvertime()]).finally(() => {
    vm.loading = false;
  });

  vm.resetModel = function() {
    vm.model = {
      employeeId: employee.employeeID,
      date: moment
        .utc()
        .startOf('day')
        .toDate(),
      correction: null,
      remark: '',
    };
    vm.correction = 0;
    if (vm.inputForm) {
      vm.inputForm.$setPristine();
      vm.inputForm.$setUntouched();
    }
  };

  vm.addRow = function() {
    if (vm.inputForm.$invalid) return;
    if (!vm.correction) return;
    if (vm.saving) return;
    vm.saving = true;
    var model = angular.copy(vm.model);
    model.correction = vm.correction * vm.factor;
    return $http
      .post(`${appUrls.api}/api/employee/OvertimeCorrection`, model)
      .then(({ data }) => {
        if (!data) return;
        var row = mapCorrection(data);
        vm.data.push(row);
        vm.data.sort(dynamicSort('-date'));
        vm.resetModel();
        return vm.refreshRemainingOvertime().then(() => {
          close(vm.overtimeRemaining, 500);
          $element.modal('hide');
        });
      }, flySvc.error)
      .finally(() => {
        vm.saving = false;
      });
  };

  vm.deleteRow = function(row) {
    if (vm.saving) return;
    vm.saving = true;

    return $http
      .delete(`${appUrls.api}/api/employee/OvertimeCorrection/${row.id}`)
      .then(() => {
        var idx = vm.data.indexOf(row);
        if (idx >= 0) {
          vm.data.splice(idx, 1);

          return vm.refreshRemainingOvertime();
        }
      }, flySvc.error)
      .finally(() => {
        vm.saving = false;
      });
  };

  vm.resetModel();
  vm.cancel = function() {
    close(vm.overtimeRemaining, 500);
  };
}
